import { AntCollapse, Panel } from '@agro-club/agroclub-shared'
import { CommentType } from 'modules/domain/comment/types'
import { refetchFunc } from 'modules/domain/common/hooks'
import { LogisticRequest } from 'modules/domain/logisticsKR/types'
import { endpoints } from 'modules/endpoints'
import { FC, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import AntCollapseHeader from 'views/components/AntCollapseHeader/AntCollapseHeader'
import { SummaryComments } from 'views/components/AntCollapseHeader/SummaryComments'
import AComments from 'views/components/Comments/AComments'
import { RightPanelComments } from 'views/components/Comments/styled'
import { useTtnFilesContext } from '../TtnFilesContext'
import { AssigneesAccordion } from './AssigneesAccordion'
import { CommonInfo } from './CommonInfo/CommonInfo'
import { FilesTtn } from './FilesTtn/FilesTtn'
import { SummaryAssigneeTeam } from './SummaryAssigneeTeam'

interface Props {
  request: LogisticRequest
  refetchRequest?: refetchFunc
  defaultActiveKey?: string
  withoutShadow?: boolean
  refetchTripsTable?: () => void
  detailed?: boolean
}

export const RequestDetailsAccordion: FC<Props> = ({
  request,
  refetchRequest,
  defaultActiveKey = 'comments',
  withoutShadow,
  refetchTripsTable,
  detailed,
}) => {
  const { t } = useTranslation('logisticsKR')
  const [commentsSummary, setCommentsSummary] = useState<string>('')
  const { ttnListTotal, ttnListParams } = useTtnFilesContext()

  const options = useMemo(
    () =>
      [
        { value: 'comments', title: t('details.accordion.comments'), isShown: request?.deal_id },
        { value: 'info', title: t('details.accordion.info'), isShown: true },
        // { value: 'documents', title: t('details.accordion.documents') },
        { value: 'assignees', title: t('details.accordion.assignees'), isShown: true },
        {
          value: 'ttnFiles',
          title: t('details.accordion.ttnFiles'),
          isShown: detailed,
        },
      ].filter((item) => item.isShown),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  const [activeKey, setActiveKey] = useState<string | string[]>(options[0].value)
  const components = {
    comments: (
      <RightPanelComments>
        <AComments
          id={request.deal_id}
          type={CommentType.deal}
          url={endpoints.dealComment(request.deal_id)}
          maxHeight={400}
          popSummary={setCommentsSummary}
        />
      </RightPanelComments>
    ),
    info: <CommonInfo request={request} />,
    // documents: '',
    assignees: <AssigneesAccordion request={request} refetchRequest={refetchRequest} />,
    ttnFiles: <FilesTtn refetchTripsTable={refetchTripsTable as () => void} />,
  }

  const summary = {
    comments: <SummaryComments summary={commentsSummary} />,
    info: '',
    // documents: '',
    assignees: <SummaryAssigneeTeam assignee={request.assignee?.full_name} assignedTeam={request.assigned_team} />,
    ttnFiles: detailed && (
      <div>
        {ttnListTotal ? t('common:thereIs') : t('common:no')}
        {Object.values(ttnListParams.filter).filter(Boolean).length > 0 ? t('details.accordion.withFilter') : ''}
      </div>
    ),
  }

  return (
    <div>
      <AntCollapse
        withoutShadow={withoutShadow}
        accordion
        bordered={false}
        defaultActiveKey={defaultActiveKey}
        onChange={(key) => setActiveKey(key)}
      >
        {options.map((option) => {
          return (
            <Panel
              key={option.value}
              header={
                <AntCollapseHeader title={option.title} summary={activeKey !== option.value && summary[option.value]} />
              }
            >
              {components[option.value]}
            </Panel>
          )
        })}
      </AntCollapse>
    </div>
  )
}
